import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";

import { Select } from "../Form";

export const Wrapper = styled("div")(() => ({
  maxWidth: "50%",
}));

export const SelectStyled = styled(Select)(() => ({
  width: "fit-content",
  alignSelf: "flex-end",
}));

export const Label = styled("span")(() => ({
  fontFamily: "Manrope",
  color: "#9CA6AF",
  fontSize: 14,
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: 0.25,
  marginRight: 5,
}));

const styles = makeStyles(() => ({
  skeleton: {
    width: "150px",
    height: 40,
  },
}));

export default styles;
